/**
 * Returns a display name for the user, supporting multiple API shapes
 * (name, firstName+lastName, or email).
 */
export function getUserDisplayName(user, fallback) {
    if (!user)
        return fallback ?? "You";
    const name = user.name?.trim();
    if (name)
        return name;
    const firstLast = [user.firstName, user.lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
    if (firstLast)
        return firstLast;
    if (user.email)
        return user.email;
    return fallback ?? "You";
}
/**
 * Returns the user's full name (firstName + lastName) when available.
 * Use for senderName in messages where full name is required.
 */
export function getUserFullName(user, fallback) {
    if (!user)
        return fallback ?? "You";
    const firstLast = [user.firstName, user.lastName]
        .filter(Boolean)
        .join(" ")
        .trim();
    if (firstLast)
        return firstLast;
    if (user.name?.trim())
        return user.name.trim();
    if (user.email)
        return user.email;
    return fallback ?? "You";
}
